module.exports = __webpack_public_path__ + "static/media/6numeral3.2f3c0ed0.jpg";